import React from "react";
import { Link } from "react-router-dom";
import { FaCalendarAlt, FaUser, FaClock, FaChevronLeft, FaShare, FaLinkedin, FaTwitter, FaFacebook, FaCheckCircle, FaExclamationTriangle } from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";

const DetailBlog12 = () => {
    const blogPost = {
        id: 10,
        title: "Nouvelle Loi sur les associations et fondations au Bénin : ce que vous devez savoir pour assurer votre conformité",
        excerpt: "La République du Bénin modernise son cadre juridique avec la Loi N° 2025-19. Découvrez les nouvelles exigences pour les associations, ONG et fondations.",
        content: `
      <div class="intro-section">
        <p class="lead-text">La République du Bénin a franchi une étape décisive dans la modernisation de son cadre juridique avec la promulgation de la <strong>Loi N° 2025-19 du 22 juillet 2025</strong> relative aux associations et aux fondations.</p>
        
        <p>Cette nouvelle législation, qui abroge la loi vieillissante du 1er juillet 1901, vise à mieux encadrer le secteur associatif, à promouvoir la bonne gouvernance et à renforcer la transparence.</p>
        
        <p>Pour les milliers d'associations, d'ONG et de fondations qui animent la société civile béninoise, cette loi introduit des changements majeurs. Loin d'être une contrainte, elle représente une <strong>opportunité de professionnaliser sa gestion</strong> et de renforcer sa crédibilité.</p>
        
        <p>Chez <strong>CINEF-EXPERTISE COMPTABLE</strong>, nous vous aidons à décrypter ces nouvelles exigences et à transformer cette transition réglementaire en un levier pour votre développement.</p>
      </div>

      <div class="section-block">
        <div class="section-header">
          <span class="section-number">01</span>
          <h2>Les Principes fondamentaux de la nouvelle loi</h2>
        </div>
        
        <p>Cette loi réaffirme et structure l'exercice de la liberté d'association au Bénin. Elle s'applique à la plupart des associations et fondations, y compris les Organisations Non Gouvernementales (ONG), à l'exception notable des partis politiques et des syndicats qui sont régis par des textes spécifiques.</p>
        
        <div class="innovations-grid">
          <div class="innovation-card">
            <div class="innovation-icon green">
              <FaCheckCircle />
            </div>
            <h4>Création simplifiée</h4>
            <p>La constitution d'une association reste libre et ne nécessite pas d'autorisation administrative préalable.</p>
          </div>
          
          <div class="innovation-card">
            <div class="innovation-icon red">
              <FaCheckCircle />
            </div>
            <h4>Guichet unique</h4>
            <p>La loi institue un registre national des associations et fondations centralisé. Toute création, modification de statuts ou changement de dirigeants doit y être déclaré.</p>
          </div>
          
          <div class="innovation-card">
            <div class="innovation-icon green">
              <FaCheckCircle />
            </div>
            <h4>Transparence par publication</h4>
            <p>Un journal du registre des associations et fondations est créé pour publier les informations essentielles, les rendant ainsi opposables aux tiers.</p>
          </div>
        </div>
      </div>

      <div class="section-block">
        <div class="section-header">
          <span class="section-number">02</span>
          <h2>Nouvelles obligations : Transparence, Comptabilité et Redevabilité</h2>
        </div>
        
        <p>C'est sur ce point que la loi apporte les changements les plus significatifs. L'objectif est clair : assurer une gestion saine et transparente, en particulier lorsque des fonds publics ou étrangers sont impliqués.</p>
        
        <div class="obligations-section">
          <h3 class="subsection-title">
            <span class="title-icon"></span>
            Obligations comptables et financières
          </h3>
          
          <div class="obligation-item">
            <div class="obligation-badge">Article 23</div>
            <div class="obligation-content">
              <h4>Tenue d'une Comptabilité Obligatoire</h4>
              <p>L'article 23 est sans équivoque : <em>"Toute association ou fondation tient une comptabilité conformément aux textes en vigueur"</em>. Fini l'approximation, une gestion comptable rigoureuse est désormais la norme pour tous.</p>
            </div>
          </div>
          
          <div class="obligation-item">
            <div class="obligation-badge">Certification</div>
            <div class="obligation-content">
              <h4>Nomination d'un Commissaire aux Comptes</h4>
              <p>Pour les associations et fondations reconnues d'utilité publique ainsi que pour les fondations d'entreprise, la nomination d'un Commissaire aux Comptes est maintenant obligatoire. Son rôle est de certifier la régularité et la sincérité des comptes annuels.</p>
            </div>
          </div>
        </div>
        
        <div class="obligations-section mt-4">
          <h3 class="subsection-title">
            <span class="title-icon"></span>
            Obligations de Reporting et de Déclaration
          </h3>
          
          <div class="reporting-list">
            <div class="reporting-item">
              <div class="reporting-marker">A</div>
              <div>
                <h4>Rapport annuel d'activités</h4>
                <p>Chaque année, les dirigeants doivent soumettre un rapport d'activités et un rapport sur les comptes à l'approbation de leurs membres.</p>
              </div>
            </div>
            
            <div class="reporting-item">
              <div class="reporting-marker">B</div>
              <div>
                <h4>Publication annuelle obligatoire</h4>
                <p>Au plus tard le <strong>30 avril</strong> de chaque année, toute association doit publier au Journal officiel un rapport général sur l'année écoulée, détaillant ses programmes, ses ressources et l'état d'exécution de ses activités.</p>
              </div>
            </div>
            
            <div class="reporting-item">
              <div class="reporting-marker">C</div>
              <div>
                <h4>Transparence sur les Financements</h4>
                <ul class="transparency-list">
                  <li>Les organismes bénéficiant de financements publics doivent soumettre un rapport détaillé sur l'utilisation des fonds alloués.</li>
                  <li>Toute ressource financière reçue d'une institution privée (nationale ou internationale) doit être déclarée à l'autorité compétente.</li>
                  <li>Lors d'activités publiques financées par des entités étrangères, l'origine de ces financements doit être expressément mentionnée au public.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section-block highlight-section">
        <div class="section-header">
          <span class="section-number">03</span>
          <h2>L'Expert-Comptable : Votre partenaire stratégique</h2>
        </div>
        
        <p class="intro-para">Ces nouvelles exigences de gouvernance et de transparence peuvent sembler complexes. C'est précisément là que l'accompagnement par un expert-comptable prend tout son sens. Il n'est plus un simple prestataire, mais un <strong>allié indispensable</strong> pour assurer la pérennité et la crédibilité de votre organisation.</p>
        
        <div class="services-grid">
          <div class="service-card">
            <div class="service-number">A</div>
            <h4>Diagnostic et Mise en Conformité</h4>
            <p>Nous analysons vos statuts actuels et vous guidons pour les adapter aux nouvelles exigences légales (principes démocratiques, règles de gouvernance, etc.).</p>
          </div>
          
          <div class="service-card">
            <div class="service-number">B</div>
            <h4>Comptabilité Conforme</h4>
            <p>Nous structurons votre comptabilité pour qu'elle réponde aux normes requises par la loi, selon la taille et les besoins de votre structure.</p>
          </div>
          
          <div class="service-card">
            <div class="service-number">C</div>
            <h4>Rapports et Déclarations</h4>
            <p>Nous préparons les rapports financiers fiables et les états nécessaires pour vos obligations de reporting envers l'État et les bailleurs.</p>
          </div>
          
          <div class="service-card">
            <div class="service-number">D</div>
            <h4>Commissariat aux Comptes</h4>
            <p>Nos experts agréés réalisent la mission légale d'audit et de certification de vos comptes, un gage de confiance essentiel.</p>
          </div>
          
          <div class="service-card">
            <div class="service-number">E</div>
            <h4>Conseil en gestion</h4>
            <p>Nous transformons ces obligations en outils de pilotage pour mieux suivre vos performances et rassurer vos partenaires.</p>
          </div>
        </div>
      </div>

      <div class="conclusion-block">
        <div class="conclusion-icon">
          <FaExclamationTriangle />
        </div>
        <h3>Une Opportunité à Saisir</h3>
        <p>La nouvelle loi sur les associations et fondations marque le début d'une ère de professionnalisation pour le secteur non lucratif au Bénin. En adoptant dès maintenant les bonnes pratiques en matière de gouvernance et de gestion financière, vous ne faites pas que respecter la loi : vous <strong>renforcez la confiance</strong> de vos membres, de vos bénéficiaires et de vos partenaires financiers.</p>
        
        <p class="conclusion-cta"><strong>Ne subissez pas cette transition, anticipez-la.</strong> L'équipe de CINEF-EXPERTISE COMPTABLE est à votre disposition pour réaliser un diagnostic de votre situation et vous proposer un plan d'accompagnement sur mesure.</p>
      </div>

      <div class="ressources-finales">
        <h4> Pour lire l'intégralité de la loi et aller plus loin :</h4>
        <ul>
          <li><a href="https://sgg.gouv.bj/" target="_blank" rel="noopener noreferrer">Loi N° 2025-19 du 22 juillet 2025</a></li>
          <li><a href="https://sgg.gouv.bj/" target="_blank" rel="noopener noreferrer">Secrétariat Général du Gouvernement - SGG Bénin</a></li>
        </ul>
      </div>
    `,
        categories: ["Juridique", "Associations", "Conformité"],
        tags: ["Associations", "Fondations", "ONG", "LoiBénin", "Réglementation", "SociétéCivile", "Conformité", "Gouvernance"],
        date: "13 Octobre 2025",
        author: "Expert CINEF-EC",
        authorTitle: "Expert-Comptable et Conseil en Gouvernance Associative",
        readTime: "8 min",
        featured: true
    };

    const similarBlogs = [
        {
            id: 1,
            title: "Recouvrement de vos Créances : Le Guide Pratique de votre Expert-Comptable",
            image: "/assets/images/image6.png",
            date: "10 octobre 2025",
            category: "Juridique"
        },
        {
            id: 3,
            title: "Optimiser la gestion de votre trésorerie : les bonnes pratiques",
            image: "/assets/images/image8.png",
            date: "25 septembre 2025",
            category: "Finance"
        }
    ];

    return (
        <>
            <Header />

            <div className="blog-content-wrapper">
                <div className="container py-5">
                    <nav className="breadcrumb-nav mb-4">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/">Accueil</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/actualites/blog">Blog</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                Nouvelle Loi Associations
                            </li>
                        </ol>
                    </nav>

                    <div className="row g-4">
                        <div className="col-lg-8">
                            <article className="blog-article">
                                <div className="article-header">
                                    <div className="categories-tags mb-3">
                                        {blogPost.categories.map((category, index) => (
                                            <span key={index} className="category-tag">{category}</span>
                                        ))}
                                    </div>
                                    
                                    <h1 className="article-title">{blogPost.title}</h1>

                                    <div className="article-meta">
                                        <div className="meta-item">
                                            <FaCalendarAlt />
                                            <span>{blogPost.date}</span>
                                        </div>
                                        <div className="meta-item">
                                            <FaUser />
                                            <span>{blogPost.author}</span>
                                        </div>
                                        <div className="meta-item">
                                            <FaClock />
                                            <span>{blogPost.readTime} de lecture</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="article-excerpt">
                                    <p>{blogPost.excerpt}</p>
                                </div>

                                <div className="article-content" dangerouslySetInnerHTML={{ __html: blogPost.content }} />

                                <div className="article-footer">
                                    <div className="article-tags">
                                        <span className="tags-label">Tags :</span>
                                        {blogPost.tags.map((tag, index) => (
                                            <Link key={index} to={`#`} className="tag-link">
                                                #{tag}
                                            </Link>
                                        ))}
                                    </div>

                                    <div className="article-share">
                                        <h5>Partager cet article</h5>
                                        <div className="share-buttons">
                                            <a href="#" className="share-btn linkedin" aria-label="Partager sur LinkedIn">
                                                <FaLinkedin />
                                            </a>
                                            <a href="#" className="share-btn twitter" aria-label="Partager sur Twitter">
                                                <FaTwitter />
                                            </a>
                                            <a href="#" className="share-btn facebook" aria-label="Partager sur Facebook">
                                                <FaFacebook />
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <div className="back-button-wrapper">
                                    <Link to="/actualites/blog" className="back-button">
                                        <FaChevronLeft /> Retour au blog
                                    </Link>
                                </div>
                            </article>
                        </div>

                        <aside className="col-lg-4">
                            <div className="sidebar-card author-card">
                                <h4 className="sidebar-title">À propos de l'auteur</h4>
                                <div className="author-info">
                                    <img src="../assets/images/image5.png" alt={blogPost.author} className="author-avatar" />
                                    <div className="author-details">
                                        <h5>{blogPost.author}</h5>
                                        <p className="author-role">{blogPost.authorTitle}</p>
                                        <p className="author-description">Spécialiste en accompagnement des associations et fondations pour leur conformité réglementaire et leur professionnalisation comptable.</p>
                                    </div>
                                </div>
                            </div>

                            <div className="sidebar-card similar-articles-card">
                                <h4 className="sidebar-title">Articles similaires</h4>
                                <div className="similar-articles">
                                    {similarBlogs.map((blog) => (
                                        <Link key={blog.id} to={`/blog/${blog.id}`} className="similar-article">
                                            <div className="similar-article-img">
                                                <img src={blog.image} alt={blog.title} />
                                                <span className="article-category">{blog.category}</span>
                                            </div>
                                            <div className="similar-article-info">
                                                <h5>{blog.title}</h5>
                                                <div className="article-date">
                                                    <FaCalendarAlt />
                                                    <span>{blog.date}</span>
                                                </div>
                                            </div>
                                        </Link>
                                    ))}
                                </div>
                            </div>

                            <div className="sidebar-card newsletter-card">
                                <h4 className="sidebar-title">Newsletter</h4>
                                <p>Restez informé des nouvelles réglementations et bonnes pratiques pour les associations</p>
                                <form className="newsletter-form">
                                    <input type="email" placeholder="Votre adresse email" required />
                                    <button type="submit" className="subscribe-btn">S'abonner</button>
                                </form>
                            </div>

                            <div className="sidebar-card resources-card">
                                <h4 className="sidebar-title">Ressources Utiles</h4>
                                <ul className="resources-list">
                                    <li><a href="https://sgg.gouv.bj/" target="_blank" rel="noopener noreferrer">SGG Bénin →</a></li>
                                    <li><a href="https://oeccabenin.bj/" target="_blank" rel="noopener noreferrer">OECCA Bénin →</a></li>
                                    <li><Link to="/services/comptabilite-fiscalite">Nos Services →</Link></li>
                                    <li><Link to="/contact">Nous Contacter →</Link></li>
                                </ul>
                            </div>
                        </aside>
                    </div>
                </div>
            </div>

            <Footer />

            <style jsx>{`
                @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

                * {
                    margin: 0;
                    padding: 0;
                    box-sizing: border-box;
                    font-family: 'Inter', sans-serif;
                }

                .blog-content-wrapper {
                    background: linear-gradient(180deg, #fafafa 0%, #ffffff 50%);
                    min-height: 100vh;
                }

                .breadcrumb-nav .breadcrumb {
                    background: transparent;
                    padding: 0;
                    margin: 0;
                    font-size: 0.875rem;
                }

                .breadcrumb-item + .breadcrumb-item::before {
                    content: "›";
                    color: #9ca3af;
                    font-size: 1.2rem;
                }

                .breadcrumb-item a {
                    color: #6b7280;
                    text-decoration: none;
                    font-weight: 500;
                    transition: color 0.2s;
                }

                .breadcrumb-item a:hover {
                    color: #dc2626;
                }

                .breadcrumb-item.active {
                    color: #111827;
                    font-weight: 600;
                }

                .blog-article {
                    background: white;
                    border-radius: 16px;
                    padding: 3rem;
                    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
                }

                .article-header {
                    margin-bottom: 2.5rem;
                    padding-bottom: 2rem;
                    border-bottom: 2px solid #f3f4f6;
                }

                .categories-tags {
                    display: flex;
                    gap: 0.75rem;
                    flex-wrap: wrap;
                }

                .category-tag {
                    background: linear-gradient(135deg, #dc2626, #16a34a);
                    color: white;
                    padding: 0.5rem 1.25rem;
                    border-radius: 24px;
                    font-size: 0.813rem;
                    font-weight: 600;
                    letter-spacing: 0.3px;
                    box-shadow: 0 4px 12px rgba(220, 38, 38, 0.2);
                }

                .article-title {
                    font-size: 2.5rem;
                    font-weight: 800;
                    line-height: 1.2;
                    color: #111827;
                    margin: 1.5rem 0;
                    letter-spacing: -0.03em;
                }

                .article-meta {
                    display: flex;
                    gap: 2rem;
                    flex-wrap: wrap;
                    margin-top: 1.5rem;
                }

                .meta-item {
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    color: #6b7280;
                    font-size: 0.875rem;
                    font-weight: 500;
                }

                .meta-item svg {
                    color: #dc2626;
                    font-size: 1rem;
                }

                .article-excerpt {
                    background: linear-gradient(135deg, #fef2f2, #f0fdf4);
                    border-left: 4px solid #dc2626;
                    padding: 2rem;
                    border-radius: 12px;
                    margin-bottom: 2.5rem;
                }

                .article-excerpt p {
                    font-size: 1.125rem;
                    line-height: 1.75;
                    color: #374151;
                    font-weight: 500;
                    margin: 0;
                }

                .article-content {
                    font-size: 1.0625rem;
                    line-height: 1.8;
                    color: #374151;
                }

                .intro-section {
                    margin-bottom: 3rem;
                }

                .lead-text {
                    font-size: 1.25rem;
                    font-weight: 600;
                    color: #111827;
                    line-height: 1.7;
                    margin-bottom: 1.5rem;
                }

                .article-content p {
                    margin-bottom: 1.5rem;
                }

                .section-block {
                    margin: 3rem 0;
                    padding: 2.5rem;
                    background: #fafafa;
                    border-radius: 16px;
                    border: 1px solid #e5e7eb;
                }

                .section-header {
                    display: flex;
                    align-items: center;
                    gap: 1.5rem;
                    margin-bottom: 2rem;
                }

                .section-number {
                    background: linear-gradient(135deg, #dc2626, #16a34a);
                    color: white;
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 1.5rem;
                    font-weight: 800;
                    flex-shrink: 0;
                    box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3);
                }

                .section-header h2 {
                    font-size: 1.875rem;
                    font-weight: 700;
                    color: #111827;
                    margin: 0;
                }

                .innovations-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
                    gap: 1.5rem;
                    margin-top: 2rem;
                }

                .innovation-card {
                    background: white;
                    padding: 2rem;
                    border-radius: 12px;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
                    transition: transform 0.3s, box-shadow 0.3s;
                }

                .innovation-card:hover {
                    transform: translateY(-4px);
                    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
                }

                // .innovation-icon {
                //     width: 50px;
                //     height: 50px;
                //     border-radius: 12px;
                //     display: flex;
                //     align-items: center;
                //     justify-content: center;
                //     margin-bottom: 1rem;
                //     font-size: 1.5rem;
                // }

                // .innovation-icon.green {
                //     background: linear-gradient(135deg, #10b981, #16a34a);
                //     color: white;
                // }

                // .innovation-icon.red {
                //     background: linear-gradient(135deg, #dc2626, #b91c1c);
                //     color: white;
                // }

                .innovation-card h4 {
                    font-size: 1.125rem;
                    font-weight: 700;
                    color: #111827;
                    margin-bottom: 0.75rem;
                }

                .innovation-card p {
                    font-size: 0.938rem;
                    color: #6b7280;
                    line-height: 1.6;
                    margin: 0;
                }

                .obligations-section {
                    margin: 2rem 0;
                }

                .subsection-title {
                    display: flex;
                    align-items: center;
                    gap: 0.75rem;
                    font-size: 1.5rem;
                    font-weight: 700;
                    color: #111827;
                    margin-bottom: 1.5rem;
                    padding-bottom: 0.75rem;
                    border-bottom: 2px solid #e5e7eb;
                }

                .title-icon {
                    font-size: 1.75rem;
                }

                .obligation-item {
                    display: flex;
                    gap: 1.5rem;
                    background: white;
                    padding: 1.75rem;
                    border-radius: 12px;
                    margin-bottom: 1.5rem;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
                }

                .obligation-badge {
                    background: linear-gradient(135deg, #dc2626, #16a34a);
                    color: white;
                    padding: 0.5rem 1rem;
                    border-radius: 8px;
                    font-weight: 700;
                    font-size: 0.875rem;
                    height: fit-content;
                    white-space: nowrap;
                }

                .obligation-content h4 {
                    font-size: 1.125rem;
                    font-weight: 700;
                    color: #111827;
                    margin-bottom: 0.75rem;
                }

                .obligation-content p {
                    margin: 0;
                    color: #4b5563;
                }

                .obligation-content em {
                    color: #dc2626;
                    font-style: italic;
                }

                .reporting-list {
                    display: flex;
                    flex-direction: column;
                    gap: 1.5rem;
                }

                .reporting-item {
                    display: flex;
                    gap: 1.5rem;
                    background: white;
                    padding: 1.75rem;
                    border-radius: 12px;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
                }

                .reporting-marker {
                    background: linear-gradient(135deg, #dc2626, #16a34a);
                    color: white;
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 800;
                    font-size: 1.25rem;
                    flex-shrink: 0;
                }

                .reporting-item h4 {
                    font-size: 1.125rem;
                    font-weight: 700;
                    color: #111827;
                    margin-bottom: 0.5rem;
                }

                .reporting-item p {
                    margin: 0;
                    color: #4b5563;
                }

                .transparency-list {
                    list-style: none;
                    padding: 0;
                    margin: 0.75rem 0 0 0;
                }

                .transparency-list li {
                    position: relative;
                    padding-left: 1.5rem;
                    margin-bottom: 0.5rem;
                    color: #4b5563;
                }
                .transparency-list li::before {
                    content: "•";
                    position: absolute;
                    left: 0;
                    color: #dc2626;
                    font-size: 1.25rem;
                    line-height: 1;
                    top: 0;
                }
                .highlight-section {
                    background: linear-gradient(135deg, #fef2f2, #f0fdf4);
                    border: 2px solid #dc2626;
                }
                .intro-para {
                    font-size: 1.125rem;
                    font-weight: 600;
                    color: #111827;
                    line-height: 1.7;
                    margin-bottom: 2rem;
                }   
                .services-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
                    gap: 1.5rem;
                }
                .service-card {
                    background: white;
                    padding: 1.75rem;
                    border-radius: 12px;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
                    transition: transform 0.3s, box-shadow 0.3s;
                }
                .service-card:hover {
                    transform: translateY(-4px);
                    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
                }
                .service-number {
                    background: linear-gradient(135deg, #dc2626, #16a34a);
                    color: white;
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 1.25rem;
                    font-weight: 800;
                    flex-shrink: 0;
                    margin-bottom: 1rem;
                    box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3);
                }   
                .service-card h4 {
                    font-size: 1.125rem;
                    font-weight: 700;
                    color: #111827;
                    margin-bottom: 0.75rem;
                }
                .service-card p {
                    font-size: 0.938rem;
                    color: #6b7280;
                    line-height: 1.6;
                    margin: 0;
                }
                .conclusion-block {
                    background: white;
                    border-radius: 16px;
                    padding: 2.5rem;
                    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
                    text-align: center;
                    margin: 3rem 0;
                }
                .conclusion-icon {
                    font-size: 3rem;
                    color: #dc2626;
                    margin-bottom: 1rem;
                }
                .conclusion-block h3 {
                    font-size: 1.875rem;
                    font-weight: 700;
                    color: #111827;
                    margin-bottom: 1rem;
                }
                .conclusion-block p {
                    font-size: 1.125rem;
                    color: #374151;
                    line-height: 1.7;
                    margin-bottom: 1rem;
                }
                .conclusion-cta {
                    font-size: 1.125rem;
                    font-weight: 600;
                    color: #111827;
                }
                .ressources-finales {
                    margin-top: 2rem;
                }
                .ressources-finales h4 {
                    font-size: 1.125rem;
                    font-weight: 700;
                    color: #111827;
                    margin-bottom: 1rem;
                }
                .ressources-finales ul {
                    list-style: none;
                    padding: 0;
                    margin: 0;
                }
                .ressources-finales ul li {
                    margin-bottom: 0.5rem;
                }
                .ressources-finales ul li a {
                    color: #dc2626;
                    text-decoration: none;
                    font-weight: 600;
                    transition: color 0.2s;
                }
                .ressources-finales ul li a:hover {
                    color: #16a34a;
                }
                .article-footer {
                    margin-top: 3rem;
                    border-top: 2px solid #f3f4f6;
                    padding-top: 2rem;
                }
                .article-tags {
                    display: flex;
                    align-items: center;
                    gap: 0.75rem;
                    flex-wrap: wrap;
                    margin-bottom: 1.5rem;
                }
                .tags-label {
                    font-weight: 600;
                    color: #6b7280;
                    font-size: 0.875rem;
                }
                .tag-link {
                    background: #f3f4f6;
                    color: #374151;
                    padding: 0.4rem 0.75rem;
                    border-radius: 24px;
                    font-size: 0.813rem;
                    font-weight: 500;
                    text-decoration: none;
                    transition: background 0.2s, color 0.2s;
                }
                .tag-link:hover {
                    background: #dc2626;
                    color: white;
                }
                .article-share {
                    text-align: right;
                    margin-top: 1.5rem;
                }
                .article-share h5 {
                    font-size: 1rem;
                    font-weight: 600;
                    color: #111827;
                    margin-bottom: 0.75rem;
                }
                .share-buttons {
                    display: flex;
                    gap: 0.75rem;
                    justify-content: flex-end;
                }
                .share-btn {
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: white;
                    font-size: 1.25rem;
                    text-decoration: none;
                    transition: transform 0.2s, box-shadow 0.2s;
                }
                .share-btn:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
                }
                .share-btn.linkedin {   
                    background: #0a66c2;
                }
                .share-btn.twitter {    
                    background: #1da1f2;
                }
                .share-btn.facebook {
                    background: #1877f2;
                }
                .back-button-wrapper {
                    text-align: center;
                    margin-top: 3rem;
                }
                .back-button {
                    display: inline-flex;
                    align-items: center;
                    gap: 0.5rem;
                    color: #6b7280;
                    font-weight: 500;
                    text-decoration: none;
                    font-size: 0.875rem;
                    transition: color 0.2s;
                }
                .back-button:hover {
                    color: #dc2626;
                }
                .back-button svg {
                    font-size: 1rem;
                    color: #dc2626;
                }
                .sidebar-card {
                    background: white;
                    border-radius: 16px;
                    padding: 1.5rem;
                    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
                    margin-bottom: 2rem;
                }
                .sidebar-title {
                    font-size: 1.25rem;
                    font-weight: 700;
                    color: #111827;
                    margin-bottom: 1rem;
                    border-bottom: 2px solid #f3f4f6;
                    padding-bottom: 0.5rem;
                }
                .author-info {
                    display: flex;
                    gap: 1rem;
                    align-items: center;
                }
                .author-avatar {
                    width: 70px;
                    height: 70px;
                    border-radius: 50%;
                    object-fit: cover;
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
                }
                .author-details h5 {
                    font-size: 1.125rem;    
                    font-weight: 700;
                    color: #111827;
                    margin: 0 0 0.25rem 0;
                }
                .author-role {
                    font-size: 0.875rem;
                    color: #6b7280;
                    margin-bottom: 0.5rem;
                }
                .author-description {
                    font-size: 0.875rem;    
                    color: #4b5563;
                    line-height: 1.5;
                    margin: 0;
                }
                .similar-articles {
                    display: flex;
                    flex-direction: column;
                    gap: 1rem;
                }
                .similar-article {
                    display: flex;
                    gap: 1rem;
                    text-decoration: none;
                    color: inherit;
                    transition: background 0.2s;
                    border-radius: 12px;
                    padding: 0.5rem;
                }
                .similar-article:hover {
                    background: #f9fafb;
                }
                .similar-article-img {
                    position: relative;
                    flex-shrink: 0;
                    width: 80px;
                    height: 80px;
                    border-radius: 12px;
                    overflow: hidden;
                }
                .similar-article-img img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transition: transform 0.3s;
                }
                .similar-article:hover .similar-article-img img {
                    transform: scale(1.05);
                }
                .article-category {
                    position: absolute;
                    bottom: 8px;
                    left: 8px;
                    background: rgba(0, 0, 0, 0.6);
                    color: white;
                    padding: 0.25rem 0.5rem;
                    border-radius: 8px;
                    font-size: 0.75rem;
                    font-weight: 600;
                    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
                }
                .similar-article-info h5 {
                    font-size: 1rem;
                    font-weight: 600;
                    color: #111827;
                    margin: 0 0 0.5rem 0;
                }
                .article-date {
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    color: #6b7280;
                    font-size: 0.813rem;
                }
                .article-date svg {
                    color: #dc2626;
                    font-size: 0.875rem;
                }
                .newsletter-card p {
                    font-size: 0.875rem;
                    color: #4b5563;
                    line-height: 1.5;
                    margin-bottom: 1rem;
                }
                .newsletter-form {
                    display: flex;
                    gap: 0.5rem;
                }
                .newsletter-form input {
                    flex: 1;
                    padding: 0.5rem 1rem;
                    border: 1px solid #d1d5db;
                    border-radius: 8px;
                    font-size: 0.875rem;
                    outline: none;
                    transition: border-color 0.2s;
                }
                .newsletter-form input:focus {
                    border-color: #dc2626;
                }
                .subscribe-btn {
                    background: #dc2626;
                    color: white;
                    border: none;
                    padding: 0.5rem 1.5rem;
                    border-radius: 8px;

                    font-size: 0.875rem;
                    font-weight: 600;
                    cursor: pointer;
                    transition: background 0.2s;
                }
                .subscribe-btn:hover {
                    background: #b91c1c;
                }
                .resources-card .resources-list {
                    list-style: none;
                    padding: 0;
                    margin: 0;
                }
                .resources-card .resources-list li {
                    margin-bottom: 0.75rem;
                }
                .resources-card .resources-list li a {
                    color: #dc2626;
                    text-decoration: none;
                    font-weight: 600;
                    transition: color 0.2s;
                }
                .resources-card .resources-list li a:hover {
                    color: #16a34a;
                }
                @media (max-width: 992px) {
                    .blog-article {
                        padding: 2rem;
                    }   
                    .article-title {
                        font-size: 2rem;
                    }
                    .article-header {
                        margin-bottom: 2rem;
                    }
                    .article-meta {
                        gap: 1rem;
                    }
                    .article-excerpt {
                        padding: 1.5rem;
                    }
                    .article-content {
                        font-size: 1rem;
                    }
                    .section-header h2 {
                        font-size: 1.5rem;
                    }
                    .section-number {
                        width: 50px;
                        height: 50px;
                        font-size: 1.25rem;
                    }
                    .innovation-icon {
                        width: 40px;
                        height: 40px;
                        font-size: 1.25rem;
                    }
                    .innovation-card h4 {
                        font-size: 1rem;
                    }
                    .subsection-title {
                        font-size: 1.25rem;
                    }
                    .title-icon {
                        font-size: 1.5rem;
                    }
                    .obligation-badge {
                        font-size: 0.813rem;

                        padding: 0.4rem 0.75rem;
                        height: fit-content;
                    }
                    .obligation-content h4 {
                        font-size: 1rem;
                        margin-bottom: 0.5rem;
                    }
                    .reporting-marker {
                        width: 35px;
                        height: 35px;
                        font-size: 1rem;
                    }
                    .reporting-item h4 {
                        font-size: 1rem;
                    }
                    .highlight-section {
                        padding: 2rem;
                    }
                    .intro-para {
                        font-size: 1rem;
                        margin-bottom: 1.5rem;
                    }
                    .service-card h4 {
                        font-size: 1rem;
                    }
                    .conclusion-block h3 {
                        font-size: 1.5rem;
                    }
                    .conclusion-block p {
                        font-size: 1rem;
                    }
                    .conclusion-cta {
                        font-size: 1rem;
                    }
                    .article-footer {
                        margin-top: 2rem;
                        padding-top: 1.5rem;
                    }
                    .article-tags {
                        margin-bottom: 1rem;
                    }
                    .tags-label {
                        font-size: 0.813rem;
                    }
                    .tag-link {
                        font-size: 0.75rem;
                        padding: 0.35rem 0.65rem;
                    }
                    .article-share h5 {
                        font-size: 0.875rem;
                    }
                    .share-btn {
                        width: 35px;
                        height: 35px;
                        font-size: 1rem;
                    }
                    .back-button {
                        font-size: 0.813rem;
                    }
                    .back-button svg {
                        font-size: 0.875rem;
                    }
                    .sidebar-card {
                        padding: 1rem;
                    }
                    .sidebar-title {
                        font-size: 1rem;
                        margin-bottom: 0.75rem;
                        padding-bottom: 0.25rem;
                    }
                    .author-avatar {
                        width: 60px;
                        height: 60px;
                    }
                    .author-details h5 {
                        font-size: 1rem;
                    }

                    .author-role {
                        font-size: 0.813rem;
                        margin-bottom: 0.25rem;
                    }
                    .author-description {
                        font-size: 0.813rem;
                    }
                    .similar-article {
                        gap: 0.75rem;
                        padding: 0.4rem;
                    }
                    .similar-article-img {
                        width: 70px;
                        height: 70px;
                    }
                    .article-category {
                        font-size: 0.688rem;
                        padding: 0.2rem 0.4rem;
                        bottom: 6px;
                        left: 6px;
                        border-radius: 6px;
                    }
                    .similar-article-info h5 {
                        font-size: 0.938rem;
                        margin-bottom: 0.25rem;
                    }
                    .article-date {
                        font-size: 0.75rem;
                    }
                    .article-date svg {
                        font-size: 0.813rem;
                    }
                    .newsletter-card p {
                        font-size: 0.813rem;
                        margin-bottom: 0.75rem;
                    }
                    .newsletter-form input {
                        font-size: 0.813rem;
                        padding: 0.4rem 0.75rem;
                    }
                    .subscribe-btn {
                        font-size: 0.813rem;
                        padding: 0.4rem 1rem;
                    }
                    .resources-card .resources-list li {
                        margin-bottom: 0.5rem;
                    }
                    .resources-card .resources-list li a {
                        font-size: 0.813rem;
                    }
                }
            `}</style>
        </>
    );
};
export default DetailBlog12;